// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { upperCaseFirst } from '@seedplanner/shared-utils';

export const getID = (id: string) => id.split(':').slice(1).join(':');

export const getNumericID = (id: string) => Number.parseInt(getID(id), 10);

const createIDInternal = (type: string, id: string | number) => {
  return `${upperCaseFirst(type)}:${String(Number(id))}`;
};
const createStringIDInternal = (type: string, id: string) => {
  return `${upperCaseFirst(type)}:${id}`;
};

export const createID = {
  crop: (id: string | number) => createIDInternal('Crop', id),
  order: (id: string | number) => createIDInternal('Order', id),
  recurringTask: (id: string | number) => createIDInternal('RecurringTask', id),
  recurringPlanting: (id: string | number) => createIDInternal('RecurringPlanting', id),
  recurringOrder: (id: string | number) => createIDInternal('RecurringOrder', id),
  planting: (id: string | number) => createIDInternal('Planting', id),
  task: (id: string | number) => createIDInternal('Task', id),
  blend: (id: string | number) => createIDInternal('Blend', id),
  blogPost: (id: string) => createStringIDInternal('BlogPost', id),
};
